<template>
  <b-row>
    <b-col
      cols="12"
    >
      <b-tabs
        pills
        fill
      >
        <b-tab @click="getProjects('approved')">
          <template #title>
            <feather-icon icon="InfoIcon" />
            Bekleyen Talepler
          </template>
          <b-card no-body>
            <b-card-header>
              <b-card-title>Satınalım Talep Listesi</b-card-title>
            </b-card-header>
            <b-table
              v-if="projects.length > 0"
              responsive="sm"
              :fields="fields"
              :items="projects"
              striped
            >
              <template #cell(title)="data">
                <div v-if="data.item.onumber">
                  <small class="text-primary">{{ data.item.onumber }}</small>
                </div>
                {{ data.item.title }}
              </template>
              <template #cell(confirmed_suppliers)="data">
                {{ data.item.confirmed_suppliers }}
              </template>
              <template #cell(control)="data">
                <b-button
                  size="sm"
                  variant="success"
                  :to="'/app/stocks/purchase-offers-in/' + data.item.id"
                  class="text-nowrap"
                >
                  <FeatherIcon icon="PlusIcon" />
                  Oluştur
                </b-button>
              </template>
            </b-table>
            <b-card-footer v-else>
              <b-alert show>
                <div class="alert-body text-center">
                  <div class="mb-1">
                    Malzeme girişi yapılabilecek satınalma talebi bulunmuyor.
                  </div>
                </div>
              </b-alert>
            </b-card-footer>
          </b-card>
        </b-tab>
        <b-tab @click="getProjects('completed')">
          <template #title>
            <feather-icon icon="InfoIcon" />
            Tamamlanan Talepler
          </template>
          <b-card no-body>
            <b-card-header>
              <b-card-title>Tamamlanan Talepler</b-card-title>
            </b-card-header>
            <b-table
              v-if="projects.length > 0"
              responsive="sm"
              :fields="fields"
              :items="projects"
              striped
            >
              <template #cell(title)="data">
                <div v-if="data.item.onumber">
                  <small class="text-primary">{{ data.item.onumber }}</small>
                </div>
                {{ data.item.title }}
              </template>
              <template #cell(confirmed_suppliers)="data">
                {{ data.item.confirmed_suppliers }}
              </template>
              <template #cell(control)="data">
                <b-button
                  size="sm"
                  variant="primary"
                  :to="'/app/stocks/purchase-offers-detail/' + data.item.id"
                  class="text-nowrap"
                >
                  <FeatherIcon icon="EyeIcon" />
                  Görüntüle
                </b-button>
              </template>
            </b-table>
            <b-card-footer v-else>
              <b-alert show>
                <div class="alert-body text-center">
                  <div class="mb-1">
                    Tamamlanmış Satınalma talebi bulunmuyor. "Bekleyen Talepler" sekmesinde bekleyen talep bulunuyor ise işlem gereklidir.
                  </div>
                </div>
              </b-alert>
            </b-card-footer>
          </b-card>
        </b-tab>
      </b-tabs>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BButton, BTable, BAlert, BCardHeader, BCardTitle, BCardFooter, BTabs, BTab,
} from 'bootstrap-vue'

export default {
  name: 'PurchaseOffersSelect',
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BTable,
    BAlert,
    BCardHeader,
    BCardTitle,
    BCardFooter,
    BTabs,
    BTab,
  },
  data() {
    return {
      keyword: '',
      fields: [
        {
          key: 'title',
          label: 'Satınalım Talebi',
        },
        {
          key: 'confirmed_suppliers',
          label: 'Tedarikçi',
        },
        {
          key: 'control',
          label: '',
          tdClass: 'text-right',
        },
      ],
    }
  },
  computed: {
    projects() {
      return this.$store.getters['purchaseOffers/dataList']
    },
  },
  created() {
    this.getProjects('approved')
  },
  methods: {
    getProjects(type = 'approved') {
      if (type === 'approved') {
        const params = {
          select: [
            'purchase_offers.id AS id',
            'purchase_offers.title as title',
            'purchase_offers.onumber as onumber',
            'confirmed_suppliers.company AS confirmed_suppliers',
          ],
          where: {
            'purchase_offers.id_purchase_offer_status': 6,
          },
          start: 0,
          limit: 10,
        }
        this.$store.dispatch('purchaseOffers/getDataList', params)
      } else if (type === 'completed') {
        const params = {
          select: [
            'purchase_offers.id AS id',
            'purchase_offers.title as title',
            'purchase_offers.onumber as onumber',
            'confirmed_suppliers.company AS confirmed_suppliers',
          ],
          where: {
            'purchase_offers.id_purchase_offer_status': 8,
          },
          start: 0,
          limit: 10,
        }
        this.$store.dispatch('purchaseOffers/getDataList', params)
      }
    },
  },
}
</script>
